// extracted by mini-css-extract-plugin
export default {"EditionPatient":"EditionPatient_EditionPatient__XDPrK"};